module.exports = __webpack_public_path__ + "static/iep-logo-9b71e07a496ddb41063decdfb2c9fcb0.png";